const GatewaySeverityIndicator = ({ severity }) => {
  const severityGradientMap = {
    low: {
      from: 'hsl(63, 100%, 20%)', // dark green
      to: 'hsl(63, 100%, 70%)', // light green (your original)
    },
    medium: {
      from: 'hsl(36, 100.00%, 22.90%)', // dark yellow
      to: 'hsl(46, 100.00%, 50.00%)', // light yellow
    },
    high: {
      from: 'hsl(0, 100%, 30%)', // dark red
      to: 'hsl(0, 100%, 62.4%)', // light red (your original)
    },
  };

  const gradient = severityGradientMap[severity] || {
    from: 'hsl(0, 0%, 40%)',
    to: 'hsl(0, 0%, 70%)',
  };

  return (
    <div
      style={{
        width: '40px',
        height: '40px',
        backgroundColor: '#212121',
        border: '1px solid hsl(0, 0.00%, 20%)',
        borderRadius: '35%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <svg
        width="25"
        height="25"
        viewBox="0 0 40 40"
        style={{ animation: 'spin 7s linear infinite' }}
      >
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={gradient.from} />
            <stop offset="100%" stopColor={gradient.to} />
          </linearGradient>
        </defs>
        <circle
          cx="20"
          cy="20"
          r="16"
          stroke="url(#my_gradient)"
          strokeWidth="2"
          fill="none"
        />
      </svg>

      {/* Add the animation keyframes */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          svg {
            transform-origin: center;
          }
        `}
      </style>
    </div>
  );
};

export default GatewaySeverityIndicator;
